import CategoriesDatatable from "../../components/admin/CategoriesDatatable";

const AdminCategories = () => {
  return <CategoriesDatatable />;
};

export default AdminCategories;
